(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ada-preorder-assets"] && !Shopify.designMode) return;
  try {
    import('@shopify/events').then(({ StandardEvents }) => {
  if (window.adaPreorderReady) return;
  window.adaPreorderReady = true;

  const SELECTOR = '[data-ada-po]';
  /** @type {WeakMap<Element | Document, Promise<void>>} */
  const pending = new WeakMap();

  const scopeOf = (el) => el.closest('dialog, .shopify-section') || document;

  const applyState = (root) => {
    root.querySelectorAll('.ada-po-note[data-state]').forEach((note) => {
      const state = note.dataset.state || 'normal';
      const details = note.closest('.product-details');
      if (details) details.dataset.adaPoState = state;

      if (state !== 'preorder' && state !== 'blocked' && state !== 'soldout') return;
      const form = note.closest('product-form-component');
      if (!form) return;
      form.querySelectorAll('[ref="acceleratedCheckoutButtonContainer"]').forEach((box) => {
        box.setAttribute('hidden', 'true');
      });
      if (state === 'preorder') return;
      form.querySelectorAll('[ref="addToCartButton"]').forEach((button) => {
        button.disabled = true;
      });
    });
  };

  document.addEventListener(StandardEvents.productSelect, (event) => {
    const target = event.target;
    if (!(target instanceof Element) || target.closest('product-card')) return;
    const scope = scopeOf(target);
    if (!scope.querySelector(SELECTOR) || !event.promise) return;

    const job = Promise.resolve(event.promise)
      .then((result) => {
        const html = result && result.detail && result.detail.html;
        if (!html) return;
        scope.querySelectorAll(SELECTOR).forEach((el) => {
          const key = el.getAttribute('data-ada-po');
          const fresh = html.querySelector(`[data-ada-po="${CSS.escape(key)}"]`);
          if (fresh) el.replaceWith(document.importNode(fresh, true));
        });
        applyState(scope);
      })
      .catch(() => {})
      .finally(() => {
        if (pending.get(scope) === job) pending.delete(scope);
      });
    pending.set(scope, job);
  });

  // Toevoegen tijdens een variantwissel: wachten tot de juiste leverdatum in het formulier staat.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.querySelector(SELECTOR)) return;
      const job = pending.get(scopeOf(form));
      if (!job) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      job.then(() => requestAnimationFrame(() => form.requestSubmit()));
    },
    true
  );

  const init = () => applyState(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Snelle-toevoeg-venster: inhoud wordt later ingeladen.
  const modal = document.getElementById('quick-add-modal-content');
  if (modal) new MutationObserver(() => applyState(modal)).observe(modal, { childList: true });
  });
  } catch(e) { console.error(e); }
})();

})();
